import { Ng2StateDeclaration } from "@uirouter/angular";
import { Error403PageComponent } from "./error.403.component";

export const error403StateDeclaration: Ng2StateDeclaration = {
  name: 'error.403',
  url: "/403",
  component: Error403PageComponent
}
